import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function FacilitiesSection() {
  const {
    t,
    language
  } = useLanguage();
  const images = [{
    src: 'https://cdn.magicpatterns.com/uploads/cF8r8TxSZPyx9bKYLHBQ8H/lore_insta.png',
    alt: 'Lorena Beauty House — Entrada & Recepción',
    label: language === 'es' ? 'Entrada y Recepción' : 'Entrance & Reception'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/rJdA3iNUd2eo7dXknvyeWY/lore_insta_1.png',
    alt: 'Lorena Beauty House — Tratamiento',
    label: language === 'es' ? 'Tratamiento' : 'Treatment'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/dGn9nR19DqmxsJerTt6H6V/lore_insta_3.png',
    alt: 'Lorena Beauty House — Láser',
    label: language === 'es' ? 'Láser' : 'Laser'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/dSseBPcTUEdorb389q8ZpP/lore_insta_4.png',
    alt: 'Lorena Beauty House — Recepción',
    label: language === 'es' ? 'Recepción' : 'Reception'
  }];
  return <section id="espacio" className="pt-4 pb-20 bg-white" data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-96">
          <div className="flex items-center justify-center space-x-3 mb-4" data-id="element-97">
            <MapPin className="w-5 h-5 text-gold" data-id="element-98" />
            <span className="text-sm font-medium text-gold uppercase tracking-widest" data-id="element-99">
              Queens, New York
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-6" data-id="element-100">
            {t('facilities', 'title')}
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-6" data-id="element-101"></div>
          <p className="text-lg text-dark/70 max-w-2xl mx-auto leading-relaxed" data-id="element-102">
            {t('facilities', 'desc')}
          </p>
        </motion.div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-id="element-103">
          {images.map((image, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="relative overflow-hidden rounded-md group aspect-[3/4] border-2 border-gold/20 shadow-md hover:shadow-xl hover:border-gold/50 transition-all duration-500" data-id="element-104">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" data-id="element-105" />
              {/* Hover overlay with label */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end justify-center pb-6" data-id="element-106">
                <motion.span className="text-white font-serif text-lg tracking-wider uppercase text-center w-full px-4" data-id="element-107">
                  {image.label}
                </motion.span>
              </div>
              {/* Gold corner accents */}
              <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-tl-md" data-id="element-108"></div>
              <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-tr-md" data-id="element-109"></div>
              <div className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-bl-md" data-id="element-110"></div>
              <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-br-md" data-id="element-111"></div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center text-gold-dark font-serif text-xl font-medium mt-10 italic" data-id="element-112">
          {t('facilities', 'cta')}
        </motion.p>
      </div>
    </section>;
}